import React from 'react'
import FolderDownload from 'mdi-material-ui/FolderDownload'

export default function Download(props) {
  return <FolderDownload {...props} />
}
